import React, { useEffect } from "react";
import Layout from "./common/Layout";

const FAQ = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <Layout>
        <section className="py-5 bg-light-primary">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h1 className="display-4 fw-bolder text-primary-s mb-4 wow animated fadeInDown">Frequently Asked Questions</h1>
                <span className="sep mt-4 mx-auto d-block wow animated fadeInUp"></span>
                <p className="lead text-muted mt-4 wow animated fadeInUp">Find answers to common questions about our TLSAE course</p>
              </div>
            </div>
          </div>
        </section>


        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="faq-content">
                  <div className="accordion" id="faqAccordion">
                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading1">
                        <button
                          className="accordion-button faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse1"
                          aria-expanded="true"
                          aria-controls="collapse1"
                        >
                          <span className="question-number me-3">1.</span>
                          What is the TLSAE course and why do I need it?
                          </button>
                        </h2>
                        <div
                          id="collapse1"
                          className="accordion-collapse collapse show"
                          aria-labelledby="heading1"
                          data-bs-parent="#faqAccordion"
                        >
                          <div className="accordion-body faq-answer">
                            <div className="d-flex align-items-start">
                              <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">The Traffic Law and Substance Abuse Education (TLSAE) course is a <b>state-mandated, 4-hour online course</b> required for first-time driver license applicants in Florida. It teaches traffic law basics, the risks of impaired driving, and how to safely share the road.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading2">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse2"
                          aria-expanded="false"
                          aria-controls="collapse2"
                        >
                          <span className="question-number me-3">2.</span>
                          Who needs to take the TLSAE course?
                        </button>
                      </h2>
                      <div
                        id="collapse2"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading2"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">The TLSAE course is required if:
                              <ul>
                                <li>• You are applying for your <b>first driver license </b> in Florida</li>
                                <li>• You are <b>under 18 years old</b> and want to take the permit test</li>
                                <li>• You have <b>never been licensed</b> in any U.S. state</li>
                              </ul>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading3">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse3"
                          aria-expanded="false"
                          aria-controls="collapse3"
                        >
                          <span className="question-number me-3">3.</span>
                          Is this course approved by the Florida HSMV?
                        </button>
                      </h2>
                      <div
                        id="collapse3"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading3"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">Yes. The course is submitted for official review and approval by the <b>Florida Department of Highway Safety and Motor Vehicles (HSMV)</b> and follows all guidelines outlined in <b>Section 322.095, Florida Statutes</b>.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading4">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse4"
                          aria-expanded="false"
                          aria-controls="collapse4"
                        >
                          <span className="question-number me-3">4.</span>
                          How long is the course?
                        </button>
                      </h2>
                      <div
                        id="collapse4"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading4"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">The TLSAE course is <b>4 hours</b>, as required by Florida HSMV standards.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading5">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse5"
                          aria-expanded="false"
                          aria-controls="collapse5"
                        >
                          <span className="question-number me-3">5.</span>
                          Can I take the course on my phone?
                        </button>
                      </h2>
                      <div
                        id="collapse5"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading5"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">Yes! The course is <b>fully mobile-responsive</b>, meaning you can access it on your phone, tablet, or desktop — and switch between devices if needed.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading6">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse6"
                          aria-expanded="false"
                          aria-controls="collapse6"
                        >
                          <span className="question-number me-3">6.</span>
                          How is the exam structured?
                        </button>
                      </h2>
                      <div
                        id="collapse6"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading6"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">You'll complete <b>40 randomized questions</b>, delivered <b>one at a time throughout the course</b>, at the end of each section. This keeps you engaged and reinforces learning in real time. The test must be passed with a <b>minimum score of 80%</b> to receive your certificate.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading7">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse7"
                          aria-expanded="false"
                          aria-controls="collapse7"
                        >
                          <span className="question-number me-3">7.</span>
                          What if I fail the test?
                        </button>
                      </h2>
                      <div
                        id="collapse7"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading7"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">If you don't pass:
                              <ul>
                                <li>• You can take <b>one retest</b> immediately, this time in a <b>single 40-question exam format</b>.</li>
                                <li>• If you fail again, you can <b>retake the full course as many times as needed</b>, though a <b>fee applies for additional attempts.</b></li>
                              </ul>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading8">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse8"
                          aria-expanded="false"
                          aria-controls="collapse8"
                        >
                          <span className="question-number me-3">8.</span>
                          How is my identity verified during the course?
                        </button>
                      </h2>
                      <div
                        id="collapse8"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading8"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">Your identity is verified using <b>personal validation questions</b> at registration and throughout the course. These are <b>time-limited and unique to you</b>. Failure to answer validation questions accurately or on time may result in course failure.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading9">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse9"
                          aria-expanded="false"
                          aria-controls="collapse9"
                        >
                          <span className="question-number me-3">9.</span>
                          How is my course completion reported?
                        </button>
                      </h2>
                      <div
                        id="collapse9"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading9"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">Once you pass the exam, your completion is <b>electronically reported to the Florida HSMV</b> — no paperwork or extra steps required.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading10">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse10"
                          aria-expanded="false"
                          aria-controls="collapse10"
                        >
                          <span className="question-number me-3">10.</span>
                          Is this course secure and private?
                        </button>
                      </h2>
                      <div
                        id="collapse10"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading10"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">Yes. The course follows strict <b>privacy, security, and accessibility</b> standards as defined by the Florida HSMV. It includes anti-cheating measures, such as disabling text copying and using randomized, timed questions.</p>
                          </div>
                        </div>
                      </div>
                            </div>

                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="heading11">
                        <button
                          className="accordion-button collapsed faq-question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse11"
                          aria-expanded="false"
                          aria-controls="collapse11"
                        >
                          <span className="question-number me-3">11.</span>
                          Can I pause and resume the course?
                        </button>
                      </h2>
                      <div
                        id="collapse11"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading11"
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body faq-answer">
                          <div className="d-flex align-items-start">
                            <i className="fa fa-info-circle text-primary-s me-3 mt-1"></i>
                            <p className="mb-0 line-h-170">Yes. The course is broken into short, digestible chapters, so you can <b>pause anytime and continue later </b> without losing progress.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="mt-5 text-center">
                    <div className="contact-support-box">
                      <h4 className="text-primary-s mb-3">
                        <i className="fa fa-question-circle me-2"></i>
                        Still have questions?
                      </h4>
                      <p className="text-muted mb-4">Can't find what you're looking for? Our support team is here to help!</p>
                      <div className="contact-info">
                        <div className="d-flex gap-2 align-items-center justify-content-center py-2">
                          <i className="fa fa-envelope text-primary-s"></i>
                          <span><strong>Email:</strong> support@floridadrivingpermit.com</span>
                        </div>
                        <div className="d-flex gap-2 align-items-center justify-content-center py-2">
                          <i className="fa fa-phone text-primary-s"></i>
                          <span><strong>Phone:</strong> 503-710-1720</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
    </Layout>
  );
};

export default FAQ;
